import { Star } from 'lucide-react'
import type { Site } from '@/api/accommodation/types'
import { aggregateRating, formatRatingValue } from '@/lib/rating'
import { Badge } from '../ui/badge'

interface AggregatedRatingBadgeProps {
  sites: Site[] | undefined
  className?: string
}

export function AggregatedRatingBadge({ sites }: AggregatedRatingBadgeProps) {
  const rating = aggregateRating(sites)
  if (!rating) return null

  return (
    <Badge variant="blurred">
      <Star className="h-3.5 w-3.5 font-bold" />
      <span>{formatRatingValue(rating.value)}</span>
    </Badge>
  )
}
